import type { InteractionWithEvent } from 'frontend/shared/javascripts/tracking'

export type SnackbarType = 'info' | 'error'

export interface SnackbarOptions {
  message: string
  type?: SnackbarType
  /** In ms; 0 disables auto-dismiss. */
  duration?: number
  dismissable?: boolean
  /** Offers to take back what the message reports; the snackbar closes without calling onClose. */
  onUndo?: () => void
  undoLabel?: string
  /** The catalogue entry the undo button implements; the call site names its key in a comment. */
  undoTracking?: InteractionWithEvent
  /** Called when the snackbar closes other than by undo: by the close button or when its time is up. */
  onClose?: () => void
}

export type SnackbarEntry = SnackbarOptions & { id: number }

export const snackbars = $state<SnackbarEntry[]>([])
let nextId = 0

export function show(options: SnackbarOptions): number {
  const id = nextId++
  snackbars.push({ id, ...options })
  return id
}

export function dismiss(id: number): void {
  const index = snackbars.findIndex((snackbar) => snackbar.id === id)
  if (index !== -1) {
    snackbars.splice(index, 1)
  }
}

export function reset(): void {
  snackbars.splice(0)
}
